import qs from 'qs'

import HttpClient from 'services/HttpClient'
import { IQuery } from 'types/slices'

export class PartnersRepository {
  api: typeof HttpClient

  constructor(api: typeof HttpClient) {
    this.api = api
  }

  getAllPartners({ query }: { query: IQuery }) {
    const initialQuery = {
      order: {
        by: 'name',
        dir: 'asc'
      }
    }
    const params = { ...initialQuery, ...query }

    return this.api.get(
      `/partners/all?${decodeURIComponent(qs.stringify(params))}`
    )
  }

  getPartnersByCountry(country: string) {
    const query = {
      order: {
        by: 'name',
        dir: 'asc'
      },
      filter: {
        country
      }
    }

    return this.api.get(
      `/partners/all?${decodeURIComponent(qs.stringify(query))}`
    )
  }

  /**
   * Partners for country + optional brand filter.
   * When landingPage === true: only partners available for LP for that brand
   * (getAvailablePartnersForBrand). Otherwise: filter by packages config.
   */
  getPartnersByCurrentCountryAndBrand(
    country: string,
    brandName: string,
    landingPage?: boolean
  ) {
    const query: Record<string, unknown> = {
      order: {
        by: 'name',
        dir: 'asc'
      },
      filter: {
        country
      },
      brandName
    }

    if (landingPage === true) {
      query.landingPage = true
    }

    return this.api.get(
      `/partners/all?${decodeURIComponent(qs.stringify(query))}`
    )
  }

  getPartnerById(id: string) {
    return this.api.get(`/partners/${id}`)
  }

  /** Partners for admin (optional filter by brand name, matches packages.config for that brand). */
  getPartnersForBrandAdmin(brandName?: string) {
    const q = brandName
      ? `?brandName=${encodeURIComponent(brandName)}`
      : ''

    return this.api.get(`/partners/all${q}`)
  }

  createPartnerForm(formData: FormData) {
    return this.api.postFormData('/partners/form', formData)
  }

  updatePartnerForm(partnerId: string, formData: FormData) {
    return this.api.patchFormData(`/partners/${partnerId}/form`, formData)
  }
}

 
export default new PartnersRepository(HttpClient)
